/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom"
import Table from 'react-bootstrap/Table';
import Cookies from 'universal-cookie';
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

let checkScheme = (scheme) => {
    let responseText = "";
    if (scheme === 0)
        responseText = "單次購買";
    else if (scheme === 1)
        responseText = "月費制";
    else if (scheme === 2)
        responseText = "小時制";

    return responseText;
}
function CartComponent() {
    let location = useLocation();
    const [page, setPage] = useState(location.state.page);
    //const [plainInfo, setPlainInfo] = useState(location.state.plainInfo);
    //const [plain, setPlain] = useState(location.state.plain);
    //const [amount, setMount] = useState(location.state.amount);
    //const [payUrl,setPayUrl] = useState("");
    const plainInfo = location.state.plainInfo;
    const plain = location.state.plain;
    const amount = location.state.amount;
    const entID = location.state.ent_id;
    const payUrl = "";
    const [promoInfo, setPromoInfo] = useState({});
    const [screenClass, setScreenClass] = useState(null);
    const [showDialog, setShowDialog] = useState(false);

    // console.log("in cart plainInfo : " + JSON.stringify(plainInfo));
    // console.log("in cart plain : " + JSON.stringify(plain));
    // console.log("in cart ent id :" + entID);
    const [ra, setRadio] = useState("123");
    function checkScreenSize() {
        var windowWidth = window.innerWidth;

        if (windowWidth >= 3000)
            setScreenClass("pagesize_ent_40");
        else if (windowWidth >= 1880 && windowWidth < 3000)
            setScreenClass("pagesize_ent_60");
        else if (windowWidth < 1880)
            setScreenClass("pagesize_ent_98");
        //console.log("screen width " + windowWidth);
    }
    function handleTOSLog() {
        let isComponentMounted = true;
        const fetchData = async () => {
            const apiUrl = "/ENT/TOSLog";
            let apiParams = {};
            let requestOptions = {};
            apiParams = {
                "access_token": cookies.get("auth_access_token"),
                "ent_id": entID
            };
            requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(apiParams)
            };

            const response = await fetch("/api" + apiUrl, requestOptions)
            const r = await response.json();
        }
        fetchData();
        return () => {
            isComponentMounted = false;
        }
    }
    window.onresize = function () {
        checkScreenSize();
    }
    const [matches1900Max, setMatches1900Max] = useState(
        window.matchMedia("(max-width: 1900px) and (min-width: 1600px)").matches
    )
    const [matches1600Max, setMatches1600Max] = useState(
        window.matchMedia("(max-width: 1600px) and (min-width: 1300px)").matches
    )
    const [matches1300Max, setMatches1300Max] = useState(
        window.matchMedia("(max-width: 1300px) and (min-width: 901px)").matches
    )
    const [matches900Max, setMatches900Max] = useState(
        window.matchMedia("(max-width: 900px) and (min-width: 768px)").matches
    )
    const [matches767Min, setMatches767Min] = useState(
        window.matchMedia("(min-width: 767px)").matches
    )
    const [matches767Max, setMatches767Max] = useState(
        window.matchMedia("(max-width: 767px) and (min-width: 376px)").matches
    )
    const [matches375Max, setMatches375Max] = useState(
        window.matchMedia("(max-width: 375px)").matches
    )
    const { product } = useParams();
    const navigate = useNavigate();
    const cookies = new Cookies();      // ＡＰＩ用access_token存取
    // console.log("in cart token => "+cookies.get("auth_access_token"));
    // console.log("in cart user => "+ JSON.stringify(cookies.get("userInfo")));

    // console.log("in Cart => "+product);
    // console.log("in page => "+page);
    const handleChange = (e) => {
        //console.log("click changeradio");
        setRadio(e.target.value);
    }

    function getHintView(page) {
        var message = <></>;
        if (page === 1) {
            message =
                <div className="illustrate_box" >
                    {/* <div style={{position:"relative",left:"20%",float:"left"}}>     */}
                    <img src={require("../../image/cart_blue.png").default} alt="instruction"  ></img>
                    {/* </div> */}
                    <p>購物車明細：確認訂購內容，若選錯商品可修改。</p>
                </div>
        } else if (page === 2) {
            message =
                <div className="illustrate_box">
                    {/* <div style={{position:"relative",left:"20%",float:"left"}}>     */}
                    <img src={require("../../image/cart_blue.png").default} alt="instruction"></img>
                    {/* </div> */}
                    <p>訂單預覽：再次說明訂購明細，作為訂單內容及費用。</p>
                </div>

        } else if (page === 3) {
            message =
                <div className="illustrate_box">
                    {/* <div style={{position:"relative",left:"20%",float:"left"}}>     */}
                    <img src={require("../../image/cart_blue.png").default} alt="instruction" ></img>
                    {/* </div> */}
                    <p>訂單成立：完成訂單，準備線上付款。</p>
                </div>
        }
        return message;
    }
    function getStepBtnName(page) {
        var message = <></>;
        if (page === 1) {
            message = "下一步，訂單預覽"
        } else if (page === 2) {
            message = "下一步，訂單成立"
        } else if (page === 3) {
            message = "下一步，線上付款"
        }
        return message;
    }
    useEffect(() => {
        //console.log("in cart access token +" +cookies.get("auth_access_token"));
        //要記得改回來
        if (cookies.get("auth_access_token") === undefined || cookies.get("auth_access_token") === "") {
            //alert("請先登入後再進行購買")
            setShowDialog(true);

        } else {
            handleTOSLog();
        }
        window
            .matchMedia("(max-width: 1900px) and (min-width: 1601px)")
            .addEventListener('change', e => setMatches1900Max(e.matches));
        window
            .matchMedia("(max-width: 1600px) and (min-width: 1301px)")
            .addEventListener('change', e => setMatches1600Max(e.matches));
        window
            .matchMedia("(max-width: 1300px) and (min-width: 901px)")
            .addEventListener('change', e => setMatches1300Max(e.matches));
        window
            .matchMedia("(max-width: 900px) and (min-width: 785px)")
            .addEventListener('change', e => setMatches900Max(e.matches));
        window
            .matchMedia("(max-width: 767px) and (min-width: 376px)")
            .addEventListener('change', e => setMatches767Max(e.matches));
        window
            .matchMedia("(min-width: 767px)")
            .addEventListener('change', e => setMatches767Min(e.matches));
        window
            .matchMedia("(max-width: 375px)")
            .addEventListener('change', e => setMatches375Max(e.matches));

        if (payUrl === "") {
            let isComponentMounted = true;
            const fetchData = async () => {
                const apiUrl = "/order/AddContract";
                let apiParams = {};
                let requestOptions = {};

                apiParams = {
                    //   "access_token":cookies.get("access_token"),
                    "promo_uuid": plainInfo.uuid,
                    "amount": amount,
                    "access_token": cookies.get("auth_access_token")
                };
                requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(apiParams)
                };

                const response = await fetch("/api" + apiUrl, requestOptions)
                const r = await response.json();

                // console.log(r.results);
                if (r.isSuccess === 0 && r.errMsg === "超過可購買次數") {
                    //alert("訂單已存在");
                    //navigate("/container/order_list");
                }
                setPromoInfo(r.results);
            }
            fetchData();
            return () => {
                isComponentMounted = false;
            }
        }
    }, []);
    return (
        <div className="content_inpage">
            <div className={screenClass}>
                <div className="content_box">
                    <br />
                    {!matches375Max && (<div className={"header_hint_step"}>
                        {/* <Row>
                <Col xs={page==1?5:2} md={2}> */}
                        <div className={page === 1 ? "oval_shape_solid" : "oval_shape_hollow"}>
                            <img src={require(page === 1 ? "../../image/cart_white.png" : "../../image/cart_blue.png").default} alt="instruction">
                            </img>
                            <div className={page === 1 ? "step_label_s" : "step_label"}>購物車明細</div>
                        </div>
                        {/* <div className="cart_hint_font">購物車明細</div> */}
                        {/* {matches1900Max &&(<div className="dash_line_1900max">-----------------------</div>)}
                    {matches1600Max &&(<div className="dash_line_1600max">------------------</div>)}
                    {matches1300Max &&(<div className="dash_line_1300max">------------</div>)}
                    {matches900Max &&(<div className="dash_line_900max">----------</div>)} */}
                        {/* </Col> */}
                        {/* <Col md={3} xs={1.5}> */}
                        <img className="step_img" src={require("../../image/cart_step_arrow.png").default} alt="step" ></img>
                        {/* </Col> */}
                        {/* <Col md={2} xs={2} > */}
                        <div className={page === 2 ? "oval_shape_solid" : "oval_shape_hollow"}>
                            <img src={require(page === 2 ? "../../image/order_list_white.png" : "../../image/order_list_blue.png").default} alt="instruction" >
                            </img>
                            <div className={page === 2 ? "step_label_s" : "step_label"}>訂單預覽</div>
                        </div>
                        {/* <div className="cart_hint_font">訂購預覽</div> */}
                        {/* {matches1900Max &&(<div className="dash_line_1900max">-----------------------</div>)}
                    {matches1600Max &&(<div className="dash_line_1600max">------------------</div>)}
                    {matches1300Max &&(<div className="dash_line_1300max">------------</div>)}
                    {matches900Max &&(<div className="dash_line_900max">----------</div>)} */}
                        {/* </Col> */}
                        {/* <Col md={3} xs={1.5}> */}
                        <img className="step_img" src={require("../../image/cart_step_arrow.png").default} alt="step"></img>
                        {/* </Col> */}
                        {/* <Col md={2} xs={2} > */}
                        <div className={page === 3 ? "oval_shape_solid" : "oval_shape_hollow"}>
                            <img src={require(page === 3 ? "../../image/payment_white.png" : "../../image/payment_blue.png").default} alt="instruction" >
                            </img>
                            <div className={page === 3 ? "step_label_s" : "step_label"}>訂單成立</div>
                        </div>
                        {/* <div className="cart_hint_font">結帳付款</div> */}
                        {/* </Col>
            </Row> */}
                    </div>
                    )//matches375Max end
                    }
                    <br />
                    {getHintView(page)}
                    <br /><br /><br /><br />
                    <Modal show={showDialog} onHide={() => setShowDialog(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>請先登入</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>登入後才可進行購買</Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" onClick={() => { navigate("/login", { state: { lastPage: "/cart/" + product, paramObj: { plainInfo: plainInfo, plain: plain, page: 1, amount: amount, ent_id: entID } } }); }}>
                                確認
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    {matches767Min && (
                        <Table bordered striped hover style={{ marginTop: "20px", fontFamily: "Inter", fontWeight: "700", fontSize: "25px" }}>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>訂單日期</th>
                                    <th>訂單編號</th>
                                    <th>優惠方案名稱</th>
                                    <th>優惠方案類型</th>
                                    <th>數量</th>
                                    <th>金額</th>
                                    <th>付款方式</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style={{ fontWeight: "400" }}>
                                    <td onClick={() => setRadio("123")} onChange={handleChange}>{(page === 1) ? <div><input type="radio" checked={ra === "123"} name="fe" value="123" /><span></span>
                                    </div> : <div></div>}</td>
                                    <td >{promoInfo.create_time}</td>
                                    <td >{promoInfo.order_no}</td>
                                    <td >{plainInfo.name}</td>
                                    <td >{checkScheme(plainInfo.pay_type)}</td>
                                    <td >{amount}</td>
                                    <td >{plainInfo.price * amount}</td>
                                    <td >信用卡</td>
                                </tr>
                            </tbody>
                        </Table>
                    )}
                    {(matches767Max || matches375Max) && (
                        <div>
                            <label className="mobile_table_head">訂單日期</label> <label className="mobile_table_content">{promoInfo.create_time}</label><br /><br />
                            <label className="mobile_table_head">訂單編號</label> <label className="mobile_table_content">{promoInfo.order_no}</label><br /><br />
                            <label className="mobile_table_head">優惠方案名稱</label> <label className="mobile_table_content">{plainInfo.name}</label><br /><br />
                            <label className="mobile_table_head">優惠方案類型</label> <label className="mobile_table_content">{checkScheme(plainInfo.pay_type)}</label> <br /><br />
                            <label className="mobile_table_head">數量</label> <label className="mobile_table_content">{amount}</label><br /><br />
                            <label className="mobile_table_head">金額</label> <label className="mobile_table_content">{plainInfo.price * amount}</label><br /><br />
                            <label className="mobile_table_head">付款方式</label> <label className="mobile_table_content">信用卡</label>
                        </div>
                    )}
                    {
                        (page < 3) ?
                            <div className="next_button" >
                                <img src={require("../../image/btn_promo.png").default} alt="instruction"
                                    onClick={() => setPage(page + 1)}>
                                </img>
                                <div className="next_button_hint" onClick={() => setPage(page + 1)}>{getStepBtnName(page)}</div>
                            </div> :
                            <div className="next_button">
                                <img src={require("../../image/btn_promo.png").default} alt="instruction" width="300px" height="50px"></img>
                                {(plainInfo.price === 0) ?
                                    <div className="next_button_hint" onClick={() => navigate('/container/order_list')

                                    }>下一步：免費訂閱</div>
                                    :
                                    <div className="next_button_hint" onClick={() => navigate('/pay',
                                        { state: { promoInfo: promoInfo } })
                                    }>下一步：線上付款</div>
                                }
                            </div>
                    }
                </div>
            </div>
        </div>
    )
}
export default CartComponent;